import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-12 flex-row py-2 px-3 row g-0 mb-2" }
const _hoisted_2 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, " Primary Care Provider ", -1 /* HOISTED */)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode(" Palliative Provider "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "field-invalid"
}
const _hoisted_11 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, " Referring Provider ", -1 /* HOISTED */)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, " Additional Provider ", -1 /* HOISTED */)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("b", { class: "fw-bolder h6" }, "+", -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Add Provider ")
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_ContactInfoCard = _resolveComponent("ContactInfoCard")!
  const _component_ContactInfoLoading = _resolveComponent("ContactInfoLoading")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Providers",
    type: "his-section",
    "full-height": false,
    "application-id": _ctx.palliativeApplication
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_TypeaheadInput, {
            id: "Primary-Care-Provider",
            getData: _ctx.getPhysicianList,
            onValueChanged: _ctx.attendingPhysicianChangedPrimaryCare,
            placeholder: "Start Typing...",
            value: _ctx.primaryCareProvider
          }, null, 8 /* PROPS */, ["getData", "onValueChanged", "value"]),
          (_ctx.primaryCareProviderInfo.firstName && !_ctx.isLoadingPrimaryCare)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_ContactInfoCard, { contactInformation: _ctx.primaryCareProviderInfo }, null, 8 /* PROPS */, ["contactInformation"])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.isLoadingPrimaryCare)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_ContactInfoLoading)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_TypeaheadInput, {
            id: "Palliative-Provider",
            getData: _ctx.getPhysicianList,
            onValueChanged: _ctx.attendingPhysicianChangedPalliativeCare,
            placeholder: "Start Typing...",
            "init-value": _ctx.palliativeProvider,
            onBlurredInput: _ctx.v$.patientDetails.providers.palliativeProviderId.$touch,
            class: _normalizeClass(`${_ctx.v$.patientDetails.providers.palliativeProviderId.$error ? 'field-invalid' : ''}`)
          }, null, 8 /* PROPS */, ["getData", "onValueChanged", "init-value", "onBlurredInput", "class"]),
          (_ctx.palliativeCareProviderInfo.firstName && !_ctx.isLoadingPalliativeCare)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_ContactInfoCard, { contactInformation: _ctx.palliativeCareProviderInfo }, null, 8 /* PROPS */, ["contactInformation"])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.isLoadingPalliativeCare)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_ContactInfoLoading)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.v$.patientDetails.providers.palliativeProviderId.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Palliative Provider is required."))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_TypeaheadInput, {
            getData: _ctx.getPhysicianList,
            onValueChanged: _ctx.attendingPhysicianChangedReferring,
            placeholder: "Search Referring Provider",
            "init-value": _ctx.referringProvider
          }, null, 8 /* PROPS */, ["getData", "onValueChanged", "init-value"]),
          (_ctx.referringProviderInfo.firstName && !_ctx.isLoadingReferringCare)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_ContactInfoCard, { contactInformation: _ctx.referringProviderInfo }, null, 8 /* PROPS */, ["contactInformation"])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.isLoadingReferringCare)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_ContactInfoLoading)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalProvider, (provider, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "form-group col-12 col-lg-4 pe-lg-3"
          }, [
            _hoisted_15,
            _createVNode(_component_TypeaheadInput, {
              getData: _ctx.getPhysicianList,
              onValueChanged: (e) => _ctx.attendingPhysicianChangedOther(e, index),
              placeholder: "Start Typing...",
              "init-value": _ctx.additionalProvider[index]
            }, null, 8 /* PROPS */, ["getData", "onValueChanged", "init-value"]),
            (_ctx.additionalProviderInfo[index].firstName && !_ctx.isLoadingAdditionalProvider[index])
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_ContactInfoCard, {
                    contactInformation: _ctx.additionalProviderInfo[index]
                  }, null, 8 /* PROPS */, ["contactInformation"])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.isLoadingAdditionalProvider[index])
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_ContactInfoLoading)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        _createElementVNode("button", {
          type: "button",
          class: "btn my-4 btn-outline-primary w-10 h-10 px-1",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addProvider && _ctx.addProvider(...args)))
        }, _hoisted_20)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}